<template>
    <el-drawer
        class="drawer"
        :title="detailData.title"
        :visible.sync="detailParam.visible"
        size="520px"
        :close-on-press-escape="false"
        :wrapperClosable="false"
    >
        <div class="drawer-wrapper">
            <div class="drawer-main" v-loading="detailData.loading.main">
                <div class="drawer-body" style="height: calc(100vh - 64px)">
                    <el-form ref="detailData" :model="detailData" size="small">
                        <el-form-item label="分配给：">
                            <el-radio-group v-model="detailData.model.rule">
                                <el-radio-button :label="1">自动分配</el-radio-button>
                                <el-radio-button :label="2">手动分配</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                        <template v-if="detailData.model.rule === 1">
                            <el-form-item
                                prop="row.users_array"
                                :rules="{ required: true, message: ' ', trigger: 'change' }"
                            >
                                <el-select v-model="detailData.row.users_array" :multiple="true">
                                    <el-option
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        v-for="item in userData.list"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <template v-if="detailData.model.rule === 2">
                            <el-form-item
                                prop="row.user_id"
                                :rules="{ required: true, message: ' ', trigger: 'change' }"
                            >
                                <el-select v-model="detailData.row.user_id">
                                    <el-option
                                        :key="item.id"
                                        :label="item.name"
                                        :value="item.id"
                                        v-for="item in userData.list"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </template>
                        <el-form-item>
                            <el-button
                                type="primary"
                                size="small"
                                :loading="detailData.loading.submit"
                                @click="SubmitDetail('detailData')"
                                >保 存</el-button
                            >
                            <el-button size="small" @click="detailParam.visible = false"
                                >取 消</el-button
                            >
                        </el-form-item>
                    </el-form>
                </div>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { UserData } from '@/plugin/User'
export default {
    inject: ['reload'],
    mixins: [UserData],
    props: ['detailParam'],
    data() {
        return {
            userData: {
                list: [],
                pages: {
                    page: 1,
                    pagesize: 9999
                }
            },
            detailData: {
                title: '分配客户',
                loading: {
                    main: false,
                    submit: false
                },
                model: {
                    rule: 1
                },
                row: {
                    user_id: null,
                    users_array: [],
                    users: null
                }
            }
        }
    },
    created() {
        this.$nextTick(() => {
            this.GetUser()
        })
    },
    mounted() {
        this.$nextTick(() => {})
    },
    watch: {
        'detailData.model.rule'(val) {
            if (val === 1) {
                this.detailData.row.user_id = null
            } else {
                this.detailData.row.users_array = []
            }
        }
    },
    methods: {
        // 用户列表
        GetUser() {
            this.detailData.loading.main = true
            this.GetUserData({
                data: {
                    ...this.userData.pages
                }
            }).then(res => {
                this.detailData.loading.main = false
                this.userData.list = res.list
            })
        },
        // 将公海客户分配给员工
        SubmitDetail(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    this.$confirm('此操作将客户分配给指定成员, 是否继续?', '警告', {
                        confirmButtonText: '确 定',
                        cancelButtonText: '取 消',
                        type: 'warning'
                    })
                        .then(() => {
                            this.detailData.loading.submit = true
                            this.$request({
                                url:
                                    this.detailData.model.rule == 1
                                        ? '/api/v1/auto_distribute_customer'
                                        : '/api/v1/hand_distribute_customer',
                                params: {
                                    users: JSON.stringify(this.detailData.row.users_array),
                                    user_id: this.detailData.row.user_id,
                                    sea_id: this.detailParam.sea_id,
                                    customers: JSON.stringify(this.detailParam.row.customers)
                                }
                            }).then(res => {
                                this.detailData.loading.submit = false
                                this.$message({
                                    message: res.message || (res.status ? '操作失败' : '操作成功'),
                                    type: res.status ? 'error' : 'success'
                                })
                                if (!res.status) {
                                    this.reload()
                                }
                            })
                        })
                        .catch(() => {})
                }
            })
        },
        ResetDetail(formName) {
            this.$refs[formName].resetFields()
        }
    }
}
</script>

<style scoped lang="less">
@import '~@/assets/css/drawer.less';
</style>
